import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'
import { useCallback, useEffect } from 'react'

export default function useBodyScrollLock(
  ref: React.RefObject<HTMLElement>,
  enable?: boolean
): { lock: () => void; unlock: () => void } {
  useEffect(() => {
    const element = ref.current
    if (enable && element) {
      disableBodyScroll(element)
    } else if (!enable && element) {
      enableBodyScroll(element)
    }

    return () => {
      clearAllBodyScrollLocks()
    }
  }, [enable, ref])

  const lock = useCallback(
    () => ref.current && disableBodyScroll(ref.current),
    [ref]
  )
  const unlock = useCallback(() => enableBodyScroll(ref.current), [ref])

  return { lock, unlock }
}
